import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactSupport = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t("contact_technical_support")}</h4>
      <p>
        Email:{" "}
        <a href="mailto:support@schoolbusapp.com">support@schoolbusapp.com</a>
      </p>
      <p>Phone: +1 (800) 123-4567</p>
      <p>
        Live Chat:{" "}
        <Link to="" rel="noreferrer">
          {t("start_chat")}
        </Link>
      </p>
    </div>
  );
};

export default ContactSupport;
